export const breadCrumb = {
  tzgg: {
    name: "通知公告",
    nameUrl: "/newsList?type=tzgg",
    subName: "公告详情",
    functionKey: "getPageList",
  },
  zwcp: {
    name: "政务产品",
    nameUrl: "/newsList?type=zwcp",
    subName: "产品详情",
    functionKey: "getPageList",
  },
  aqcp: {
    name: "安全产品",
    nameUrl: "/newsList?type=tzgg",
    subName: "产品详情",
    functionKey: "getPageList",
  },
  xmal: {
    name: "项目案例",
    nameUrl: "/newsList?type=xmal",
    subName: "案例详情",
    functionKey: "getPageList",
  },
  cjwt: {
    name: "常见问题",
    nameUrl: "/newsList?type=cjwt",
    subName: "问题详情",
    functionKey: "getPageList",
  },
  zzry: {
    name: "资质荣誉",
    nameUrl: "/newsList?type=zzry",
    subName: "荣誉详情",
    functionKey: "getPageList",
  },
};
